import { Injectable } from '@angular/core';
import { WindowRef } from '@Common/browser';
import { ExtensionService, TimeoutError } from './extension.service';

const ExtId = 'fastx@starnet.com'


@Injectable()
export class SshAgentExtensionService extends ExtensionService{
  loaded;
  failedError = {} as any;
  constructor(
    private wref: WindowRef
    ) {
      super();
    }
    agentConnected() {
      return this.loaded;
    }
    async loadSshAgent() {
      this._isEnabled();
      if(this.loaded) {
        return this.loaded;
      }
      this.myDiv.dispatchEvent(new CustomEvent('loadSshAgent', {
        detail: {}
      }));
      return new Promise((resolve, reject) => {
       
        let to = setTimeout(() => {
          reject(new TimeoutError("SSH Agent failed"))
        },5000);
        this.myDiv.addEventListener('ssh-agent-status', (e:any) => {
          clearTimeout(to);
          try {
            let res = JSON.parse(e.detail);
          
            if(res.error) {
              this.failedError = res.error;
              reject(res);
              return;
            }
            this.loaded = res
            resolve(res);
          } catch(e) {
            this.failedError = e;
            reject(e);
          }
        });
       
      });    
    }
    async requestIdentities(data?) {
      this._isEnabled()
      if(!this.loaded) {
        throw new Error("Native agent not loaded");
      }
      let ids = (await this.sendMessage("request-identities", data) ) as any;
      if(ids.identities) {
        return ids.identities.map(c => c.blob );
      }
      return ids;
    }
    async sign(data) {
      this._isEnabled();
      if(!this.loaded) {
        throw new Error("Native agent not loaded");
      }
      let o = await this.sendMessage("sign-request", {
        blob: data.pubKey || '',
        data: data.signData || '',
        flags: data.flags || 0,
    });

      return o;
    }
}
